import {
  convertIntegerToBoolean,
  isValidBooleanInteger,
} from "src/app/shared/utils/number";
import { Flow, FlowResponse, FlowStep, QrCodeResponse } from "../models/flow";

export function getFlowResponse(response: any): FlowResponse | null {
  if (!response) {
    return null;
  }
  return {
    flow: getFlow(response.flow),
    flowAccessToken: response.flow_access_token,
  };
}

function getFlow(response: any): Flow | null {
  if (!response) {
    return null;
  }
  return {
    activeStep: getFlowStep(response.active_step),
    passedSteps: response.passed_steps.map(getFlowStep),
    typeCode: response.type_code,
  };
}

function getFlowStep(response: any): FlowStep | null {
  if (!response) {
    return null;
  }
  const flowStep: FlowStep = {
    typeCode: response.type_code,
    otpTokenExpiredInSeconds: parseInt(response.otp_token_expired_in_sec),
    allowResendInSeconds: parseInt(response.allow_resend_in_sec),
    otpLength: parseInt(response.otp_length),
  };
  if (response.link) {
    flowStep.link = response.link;
  }
  if (isValidBooleanInteger(response.optional)) {
    flowStep.optional = convertIntegerToBoolean(response.optional);
  }
  if (isValidBooleanInteger(response.passed)) {
    flowStep.passed = convertIntegerToBoolean(response.passed);
  }
  if (isValidBooleanInteger(response.should_generate_qr_code)) {
    flowStep.shouldGenerateQrCode = convertIntegerToBoolean(
      response.should_generate_qr_code,
    );
  }
  return flowStep;
}

export function getQrCode(response: any): QrCodeResponse {
  return {
    qrCode: response.qr_code,
    textCode: response.text_code,
  };
}
